/**
 * Navigation & Layout Icons
 * 
 * Icons for menus, routing, page layouts, and navigation controls.
 * 
 * Used by: Top nav, sidebar, routing, page layout
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHouse as fadHouse,
  faRectangleList as fadRectangleList,
  faListCheck as fadListCheck,
  faSliders as fadSliders,
  faLayerPlus as fadLayerPlus,
  faLayerGroup as fadLayerGroup,
  faGrid as fadGrid,
  faGrid2 as fadGrid2,
  faBoxes as fadBoxes,
  faBoxesStacked as fadBoxesStacked,
  faArrowRightFromBracket as fadArrowRightFromBracket,
  faRightFromBracket as fadRightFromBracket,
  faUpRightFromSquare as fadUpRightFromSquare,
  faArrowUpFromBracket as fadArrowUpFromBracket,
  faArrowsCross as fadArrowsCross,
  faArrowsLeftRight as fadArrowsLeftRight,
  faArrowsRotate as fadArrowsRotate,
  faRotateRight as fadRotateRight,
  faRotateLeft as fadRotateLeft,
  faAngleDoubleRight as fadAngleDoubleRight,
  faAngleDoubleLeft as fadAngleDoubleLeft,
  faBarsFilter as fadBarsFilter,
  faRoute as fadRoute,
  faTimelineArrow as fadTimelineArrow,
  faSun as fadSun,
  faMoon as fadMoon,
  faMoonStars as fadMoonStars,
  faCircleDot as fadCircleDot,
  faSidebar as fadSidebar,
  faMapPin as fadMapPin,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faGrid2 as fasGrid2,
  faGrid as fasGrid,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faRectangleList as fatRectangleList,
} from "@fortawesome/pro-thin-svg-icons";

export const loadNavigationIcons = () => {
  // Duotone navigation icons
  library.add(
    fadHouse,
    fadRectangleList,
    fadListCheck,
    fadSliders,
    fadLayerPlus,
    fadLayerGroup,
    fadGrid,
    fadGrid2,
    fadBoxes,
    fadBoxesStacked,
    fadArrowRightFromBracket,
    fadRightFromBracket,
    fadUpRightFromSquare,
    fadArrowUpFromBracket,
    fadArrowsCross,
    fadArrowsLeftRight,
    fadArrowsRotate,
    fadRotateRight,
    fadRotateLeft,
    fadAngleDoubleRight,
    fadAngleDoubleLeft,
    fadBarsFilter,
    fadRoute,
    fadTimelineArrow,
    fadSun,
    fadMoon,
    fadMoonStars,
    fadCircleDot,
    fadSidebar,
    fadMapPin,
  );

  // Solid navigation icons
  library.add(
    fasGrid2,
    fasGrid,
  );

  // Thin navigation icons
  library.add(fatRectangleList);
};
